<div class="flex-[1_1_100%] mat-typography" id="dashboard" (window:resize)="resize()">
  <div class="flex flex-col flex-[1_1_100%]">
    <overview-toolbar
      [activeProgress]="activeProgress"
      [updateButton]="isUpdateable"
      [filterControls]="isFilterable"
      (updateEmitter)="refreshChart();"
      [storeList]="storeList"
      [clientList]="clientList"
      (changesEmitter)="storeAndDateChanged($event)"
      [downloadButton]="isDownloadable"
      (downloadEmitter)="downloadPdf()"
      (vatOnChanged)="changeVatValues($event)"
      [storeSelector]="storeSelectorOn"
      [clientsSelector]="hasChildren"
      [compareRevenue]="true"
      [compareRevenueOn]="isCompareRevenueOn"
      (compareRevenueOnChanged)="setVisibleCompareValues($event)"
      [compareRevenueText]="compareRevenueToDates.trim() ? ('COMPARED_TO' | translate) + ' ' + compareRevenueToDates : ''"
      [vatNumbers]="true"
      [vatOn]="true"
      id="toolbarView"
      #toolbarView
    ></overview-toolbar>
    <div class="h-full">
      <div class="flex flex-col lg:flex-row flex-wrap dsh-main-content p-5 pb-0" id="dashboardHeader">
        <mat-card class="info-card-header flex-auto">
          <div class="flex flex-col lg:flex-row w-full h-full min-w-full min-h-full gap-5 p-[30px]">
            <span class="item-align-left flex-[0_1_30%]">
              <mat-card-title class="main-title">
                {{'TRANSACTIONS' | translate}}
              </mat-card-title>
              <mat-card-title class="main-key-figure">
                <b>{{dashboardDataView.transactions || '0'}}</b>
                <small>
                  @if (graphMode === 2 && (dashboardDataView.returned && ((dashboardDataView.returned !== '0,00') && (dashboardDataView.returned !== '0.00')))) {
                    <b
                    class="small-title">{{'/' + dashboardDataView.returned + ' returned'}}</b>
                  }
                </small>
              </mat-card-title>
              <mat-card-title class="main-comparison-figure" [class.compare-visible]="isCompareRevenueOn">
                <div class="flex flex-col justify-center items-start gap-[5px]">
                  <div class="flex flex-row gap-2.5">
                    <b>{{dashboardDataView.comparedTransactions || '0'}}</b>
                    <b class="main-percentage" [class.primary]="isSign(dashboardDataView.comparedTransactionsPercentage) === false" [class.warn]="isSign(dashboardDataView.comparedTransactionsPercentage) === true">{{(dashboardDataView.comparedTransactionsPercentage || '0') + '%'}}</b>
                  </div>
                </div>
              </mat-card-title>
              <mat-card-content class="main-revenue-content">
                <div class="flex flex-col justify-center items-start gap-[5px]">
                  <div class="flex flex-row">
                    {{('AVERAGE_ITEMS' | translate) + ' / ' + ('TRANSACTIONS' | translate) + ' :'}}
                  </div>
                  <div class="flex flex-row main-smaller-figure">
                    {{dashboardDataView.averageItems || '0'}}
                  </div>
                  <div class="flex flex-row gap-2.5 main-comparison-figure" [class.compare-visible]="isCompareRevenueOn">
                    <b>{{dashboardDataView.comparedAverageItem || '0'}}</b>
                    <b class="main-percentage" [class.primary]="isSign(dashboardDataView.averageItemPercentage) === false" [class.warn]="isSign(dashboardDataView.averageItemPercentage) === true">{{(dashboardDataView.averageItemPercentage || '0') + '%'}}</b>
                  </div>
                </div>
              </mat-card-content>
            </span>
            @if (dashboardDataView.sharedSales && dashboardDataView.sharedSales.length > 0) {
              <span class="divider-dash hidden sm:block"></span>
            }
            @if (dashboardDataView.sharedSales && dashboardDataView.sharedSales.length > 0) {
              <mat-divider [attr.aria-orientation]="'vertical'"
              class="!block sm:!hidden relative"></mat-divider>
            }
            @if (dashboardDataView.sharedSales && dashboardDataView.sharedSales.length > 0) {
              <span class="flex-[0_1_70%] item-align-left">
                <mat-card-content class="transactions-card-content">
                  <div class="flex flex-col justify-center items-start gap-3 full-block">
                    @for (sale of dashboardDataView.sharedSales; track sale) {
                      <div class="flex flex-row justify-start items-center gap-[5px] full-block">
                        <div class="flex flex-col justify-center items-start flex-[0_1_35%]">
                          {{sale.type}} :
                        </div>
                        <div class="flex flex-col justify-center items-end flex-[0_1_20%]">
                          {{sale.percent + '%'}}
                        </div>
                        <div class="flex flex-col justify-center items-end flex-[0_1_45%]">
                          {{sale.amount + ' ' + currentCurrency}}
                        </div>
                      </div>
                    }
                    <div class="flex flex-row justify-start items-center gap-[5px] full-block"
                    [class.mt-5]="dashboardDataView.sharedSales && dashboardDataView.sharedSales.length > 0">
                    <div class="flex flex-col justify-center items-start flex-[0_1_35%]">
                      {{ 'CARD_TIPS' | translate }} :
                    </div>
                    <div class="flex flex-col justify-center items-end flex-[0_1_20%]"></div>
                    <div class="flex flex-col justify-center items-end flex-[0_1_45%]">
                      {{ (dashboardDataView.totalCardTipsAmount || '0,00') + ' ' + currentCurrency }}
                    </div>
                  </div>
                  <div class="flex flex-row justify-start items-center gap-[5px] full-block">
                    <div class="flex flex-col justify-center items-start flex-[0_1_35%]">
                      {{ 'CASH_TIPS' | translate }} :
                    </div>
                    <div class="flex flex-col justify-center items-end flex-[0_1_20%]"></div>
                    <div class="flex flex-col justify-center items-end flex-[0_1_45%]">
                      {{ (dashboardDataView.totalCashTipsAmount || '0,00') + ' ' + currentCurrency }}
                    </div>
                </div>
                  </div>
                </mat-card-content>
              </span>
            }
          </div>
        </mat-card>
        <mat-card class="info-card-header flex-auto">
          <div class="flex flex-row w-full h-full min-w-full min-h-full p-[30px]">
            <span class="flex flex-col">
              <mat-card-title class="main-title">
                {{'REVENUE' | translate}}
              </mat-card-title>
              <mat-card-title class="main-key-figure">
                <b>{{dashboardDataView.totalRevenue || '0'}} {{' ' + currentCurrency}}</b>
              </mat-card-title>
              <mat-card-title class="main-comparison-figure" [class.compare-visible]="isCompareRevenueOn">
                <div class="flex flex-col justify-center items-start gap-[5px]">
                  <div class="flex flex-row gap-2.5">
                    <b>{{(dashboardDataView.comparedTotalRevenue || '0') + ' ' + currentCurrency}}</b>
                    <b class="main-percentage" [class.primary]="isSign(dashboardDataView.totalRevenuePercentage) === false" [class.warn]="isSign(dashboardDataView.totalRevenuePercentage) === true">{{(dashboardDataView.totalRevenuePercentage || '0') + '%'}}</b>
                  </div>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
                  @if (dashboardDataView.revenueByVatPercentage?.length) {
                    <div class="revenue-by-tax-section">
                      <div class="flex revenue-by-tax-header">
                        <span class="col-tax-account">{{'TAX_ACCOUNT' | translate}}</span>
                        <span class="col-revenue">{{'REVENUE' | translate}}</span>
                        <span class="col-vat">{{'VAT' | translate}}</span>
                      </div>
                      <div class="flex flex-col gap-1 revenue-by-tax-rows">
                        @for (row of dashboardDataView.revenueByVatPercentage; track trackItemFn($index, row)) {
                          <div class="flex items-center revenue-by-tax-row">
                            <span class="col-tax-account">{{row.taxAccount}}</span>
                            <span class="col-revenue">{{row.revenue}} {{currentCurrency}}</span>
                            <span class="col-vat">{{row.vat}} {{currentCurrency}}</span>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div fxLayout="row" class="mt-4">
                    {{('AVERAGE_REVENUE' | translate) + ' / ' + ('TRANSACTIONS' | translate) + ' : '}}
                  </div>
                  <div class="flex flex-row main-smaller-figure">
                    {{dashboardDataView.averageRevenue || '0'}} {{' ' + currentCurrency}}
                  </div>
                  <div class="flex flex-row gap-2.5 main-comparison-figure" [class.compare-visible]="isCompareRevenueOn">
                    <b>{{(dashboardDataView.comparedAverageRevenue || '0') + ' ' + currentCurrency}}</b>
                    <b class="main-percentage" [class.primary]="isSign(dashboardDataView.averageRevenuePercentage) === false" [class.warn]="isSign(dashboardDataView.averageRevenuePercentage) === true">{{(dashboardDataView.averageRevenuePercentage || '0') + '%'}}</b>
                  </div>
                  @if (dashboardDataView.averagePerGuest) {
                    <div class="flex flex-row">
                      {{('AVERAGE_PER_GUEST' | translate) + ' :'}}
                    </div>
                  }
                  @if (dashboardDataView.averagePerGuest) {
                    <div fxLayout="row" class="main-smaller-figure">
                      {{dashboardDataView.averagePerGuest || '0'}}
                    </div>
                  }

                  <div class="flex flex-row">
                    {{('REV_WITHOUT_VOUCHERS' | translate) + ' : '}}
                  </div>
                  <div class="flex flex-row main-smaller-figure">
                    {{dashboardDataView.totalRevenueExclGiftsVouchers || '0'}} {{' ' + currentCurrency}}
                  </div>
                </div>
              </mat-card-content>
            </span>
          </div>
        </mat-card>
        <mat-card class="info-card-header flex-auto min-w-0">
          <div class="flex sm:flex-row flex-col w-full h-full min-w-0 min-h-full gap-5 p-[30px]">
            <div class="flex-auto min-w-0 item-align-left">
              <mat-card-title class="main-title">
                {{('NEW_CUSTOMERS' | translate)}}
              </mat-card-title>
              <mat-card-title class="main-key-figure">
                <b>{{dashboardDataView.newCustomers || '0'}}</b>
              </mat-card-title>
              <mat-card-title class="main-comparison-figure" [class.compare-visible]="isCompareRevenueOn">
                <div class="flex flex-col justify-center items-start gap-[5px]">
                  <div class="flex flex-row gap-2.5">
                    <b>{{dashboardDataView.comparedNewCustomers || '0'}}</b>
                    <b class="main-percentage" [class.primary]="isSign(dashboardDataView.newCustomersPercentage) === false" [class.warn]="isSign(dashboardDataView.newCustomersPercentage) === true">{{(dashboardDataView.newCustomersPercentage || '0') + '%'}}</b>
                  </div>
                </div>
              </mat-card-title>
              <mat-card-content class="main-revenue-content">
                <div class="flex flex-col justify-center items-start gap-[5px]">
                  <div class="flex flex-row">
                    {{('ALL_REG_CUSTOMERS' | translate) + ' : '}}
                  </div>
                  <div class="flex flex-row main-smaller-figure">
                    {{dashboardDataView.regCustomers || '0' }}
                  </div>
                  <div class="flex flex-row gap-2.5 main-comparison-figure" [class.compare-visible]="isCompareRevenueOn">
                    <b>{{dashboardDataView.comparedCustomers || '0'}}</b>
                    <b class="main-percentage" [class.primary]="isSign(dashboardDataView.customersPercentage) === false" [class.warn]="isSign(dashboardDataView.customersPercentage) === true">{{(dashboardDataView.customersPercentage || '0') + '%'}}</b>
                  </div>
                </div>
              </mat-card-content>
            </div>
            <span class="divider-dash hidden sm:block"></span>
            <mat-divider [attr.aria-orientation]="'vertical'" class="!block sm:!hidden relative"></mat-divider>
            <div class="item-align-left flex-auto min-w-0">
              <mat-card-content class="!flex !flex-col !gap-2.5 min-w-0">
                <div class="w-full min-w-0">{{'(' + shownDate + ')'}}</div>
                <div class="flex w-full min-w-0 items-center justify-between gap-2">
                  <span class="min-w-0">{{('NOT_REGISTERED' | translate) + ': '}}</span>
                  <span class="shrink-0 text-end">{{dashboardDataView.notRegCustomers || '0'}}</span>
                </div>
                <div class="flex w-full min-w-0 items-center justify-between gap-2">
                  <span class="min-w-0">{{('RETURNING' | translate) + ': '}}</span>
                  <span class="shrink-0 text-end">{{dashboardDataView.returnCustomers || '0'}}%</span>
                </div>
                <div class="flex w-full min-w-0 items-center justify-between gap-2">
                  <span class="min-w-0">{{('NEW_REGISTERED' | translate) + ': '}}</span>
                  <span class="shrink-0 text-end">{{dashboardDataView.newRegCustomers || '0' }} %</span>
                </div>
              </mat-card-content>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="dsh-main-content gap-[1%] flex flex-row p-6" id="chartContentView">
        <mat-card class="flex flex-row flex-[1_1_100%] h-[400px] max-w-full">
          <div class="w-full h-full" #spanVis>
            <mat-tab-group class="sub-tabs">
              <mat-tab label="{{( graphLabel | translate) | uppercase}}">
                @if (chartView) {
                  <shopbox-chart #pChart type="bar" [options]="options" [width]="widthSV" [height]="heightSV" [data]="dataGraph"></shopbox-chart>
                }
              </mat-tab>
            </mat-tab-group>
          </div>
        </mat-card>
      </div>
      @if (storeSelectorOn) {
        <div class="dsh-main-content flex flex-col xl:flex-row flex-wrap p-3.5 pt-0" id="dashboardFooter">
          @for (item of footerCards; track item; let i = $index) {
            <mat-card  class="info-card-footer flex-auto">
              <mat-card-header>
                <mat-card-title>
                  {{item | translate}}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content >
                <div class="py-0 px-5 flex flex-col justify-center items-start gap-3 full-block">
                  @for (source of footerDataSources[i]; track source) {
                    <div class="flex flex-row justify-start items-center gap-[5px] full-block">
                      <div class="flex flex-col justify-center items-start flex-[1_1_30%] name">
                        {{source.name}}:
                      </div>
                      <div class="flex flex-col justify-center items-end flex-[1_1_40%] span-units">
                        {{source.viewValue + ' ' + currentCurrency}}
                      </div>
                      @if (source.units) {
                        <div class="flex flex-col justify-center items-end flex-[1_1_30%] span-units">
                          {{'(' + source.units + ' units)'}}
                        </div>
                      }
                      @if (source.transactions) {
                        <div class="flex flex-col justify-center items-end flex-[1_1_50%] span-units">
                          {{'(' + source.transactions + ' ' + ('TRANSACTIONS' | translate).toLowerCase() + ')'}}
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- <div>
                <div class="flex flex-col flex-[1_1_40%] name"></div>
                <div class="flex flex-col flex-[1_1_60%]">
                  <div class="flex flex-row gap-5">
                    <div class="flex-[1_1_50%]"></div>
                    <div class="span-units w-1/2" *ngIf="source.units"></div>
                    <div class="span-units w-1/2" *ngIf="source.transactions"> {{'(' + source.transactions + ' ' + ('TRANSACTIONS' | translate).toLowerCase() + ')'}}</div>
                  </div>
                </div>
              </div> -->
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
  </div>
</div>
</div>
